import script from "./PaymentManual.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentManual.vue?vue&type=script&setup=true&lang=js"

import "./PaymentManual.vue?vue&type=style&index=0&id=f5f52fdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5f52fdc"]])

export default __exports__